var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNumberGreenTwo = function SvgNumberGreenTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 7,
    y: 7,
    fill: "#51C394",
    rx: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 38.4,
    x: 3.8,
    y: 3.8,
    stroke: "#51C394",
    strokeOpacity: 0.5,
    strokeWidth: 6.4,
    rx: 19.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.047 30 6.105-6.374q.519-.558.883-1.037.366-.48.557-.96t.192-.999q0-.365-.134-.71a1.8 1.8 0 0 0-.403-.614q-.27-.27-.653-.423a2.1 2.1 0 0 0-.883-.173q-.71 0-1.23.346-.498.327-.786.94-.27.615-.27 1.422h-2.687q0-1.44.576-2.592a4.4 4.4 0 0 1 1.69-1.824q1.132-.692 2.764-.692 1.21 0 2.112.384.922.366 1.517.98.615.595.902 1.324.308.73.308 1.46 0 1.074-.519 2.016a6.6 6.6 0 0 1-1.363 1.708l-3.494 3.303h5.625V30z"
  })));
};
export default SvgNumberGreenTwo;